import {ServiceBase} from '../ServiceBase';
import {ISdkComponentFactoryService, ISdkComponentRenderer} from './sdk-component-factory.service.interface';

export class SdkComponentFactoryService extends ServiceBase implements ISdkComponentFactoryService {
  createComponentRenderer(componentId: string): ISdkComponentRenderer {
    return this.services.sdk.createComponentRenderer(componentId);
  }
}
